<template>
    <b-overlay :show="busy" spinner-type="grow" spinner-variant="primary" rounded="sm">
        <b-card class="standardpage reports invoices border-none highlight-container">
            <div class="availtable datatable text-left ">
                <b-card-body class="py-0 px-0">
                    <b-tabs class="gridtabs" v-model="tabIndex">
                        <b-tab active>
                            <template #title>
                                <i :class="icon" class="text-primary mr-1"></i>
                                {{ item.yourref }}
                                <span class="text-warning">&lt;{{ selection.length == 0 ? "new" : "edit" }}&gt;</span>
                            </template>
                            <p class=" px-0">
                                <b-row align-v="end" class="nopadding my-0 mt-2 background-transparent" no-gutters>
                                    <b-col cols="12" class="text-left text-orange mt-n2 divider ">
                                        General
                                    </b-col>
                                </b-row>
                            <div class="row">
                                <div class="px-3 col-12">
                                    <b-form-group :label="$helpers.requiredlabel(
                                        requirement,
                                        'Your Ref / PO (incl. Requistion Nos e.g. A,B,C)'
                                    )
                                        " :class="$helpers
                                            .requiredlabel(
                                                requirement,
                                                'Your Ref / PO (incl. Requistion Nos e.g. A,B,C)'
                                            )
                                            .slice(0, 1) == '*'
                                            ? 'text-danger'
                                            : ''
                                            " label-size="sm" label-cols="12">
                                        <!-- label="Your Ref / PO (incl. Requistion No's e.g. A,B,C)"
                    label-for="yourref" -->
                                        <b-form-textarea id="data" v-model="item.yourref" placeholder="Your Ref"
                                            rows="2" class="smalltextarea" trim></b-form-textarea>
                                    </b-form-group>
                                </div>
                            </div>

                            <div class="row">
                                <div class="px-3 col-12 col-sm-6">
                                    <!-- <b-form-group label="Description (Leave empty for Event Name)" -->
                                    <b-form-group label="Description" label-for="description" label-cols="12">
                                        <b-input-group>
                                            <b-form-input type="text" v-model="item.description"
                                                placeholder="Description" size="sm" trim></b-form-input>
                                            <b-input-group-append>
                                                <b-button size="sm" variant="outline-secondary"
                                                    @click="item.description = ''">
                                                    <i class="la la-times"></i>
                                                </b-button>
                                            </b-input-group-append>
                                        </b-input-group>
                                    </b-form-group>
                                </div>

                                <!-- <div class="px-3 col-12 col-sm-6 col-md-4 col-lg-3">
                                    <b-form-group label-cols="12" label="Event" label-size="sm">
                                        <b-input-group class="treeselect_all" style="left:42px; top:-22px">
                                            <i class="fa fa-info-circle text-black" id="eventcode"></i>
                                        </b-input-group>
                                        <b-tooltip target="eventcode" triggers="hover" placement="top">Enter an
                                            eventcode to set the
                                            description as
                                            event name, alternatively add a description.</b-tooltip>
                                        <treeselect placeholder="Select event..."
                                            searchPromptText="Type at least 4 chars..." v-model="item.eventcode"
                                            :clearable="true" :async="true" :load-options="treeselect_loadEvent"
                                            :show-count="true" :flatten-search-results="true"
                                            :disable-branch-nodes="true" :matchKeys="['id']" search-nested
                                            :multiple="true" style="margin-top:-11px">
                                            <div slot="value-label" slot-scope="{ node }">
                                                {{ node.raw.id }}
                                            </div>
                                        </treeselect>
                                    </b-form-group>
                                </div>
                                <div class="px-3 col-12 col-sm-6 col-md-4 col-lg-3">
                                    <b-form-group label-cols="12" :label="$helpers.requiredlabel(requirement, 'Client SL A/C')
                                        " :class="$helpers
                                            .requiredlabel(requirement, 'Client SL A/C')
                                            .slice(0, 1) == '*'
                                            ? 'text-danger'
                                            : ''
                                            " label-size="sm">
                                        <treeselect placeholder="Select slac..."
                                            searchPromptText="Type at least 3 chars..." v-model="item.slac"
                                            :clearable="true" :async="true" :load-options="treeselect_loadSLAC"
                                            :show-count="true" :flatten-search-results="true"
                                            :disable-branch-nodes="true" :matchKeys="['id']" search-nested
                                            :disabled="readonly" :multiple="true">
                                            <div slot="value-label" slot-scope="{ node }">
                                                {{ node.raw.id }}
                                            </div>
                                        </treeselect>
                                    </b-form-group>
                                </div> -->
                                <div class="px-3 col-12 col-sm-6 col-md-4 col-lg-3">
                                    <b-form-group :disabled="readonly" label-cols="12" label="Placed At"
                                        label-size="sm">
                                        <b-input-group class="treeselect_all" style="left:68px; top:-27px">
                                            <!-- <i class="fa fa-info-circle text-light" id="mapper_placed_at"></i> -->
                                            <span class="tooltip-wrap">
                                                <i class="fa fa-info-circle text-light"></i>
                                                <span class="tooltip-text">This date also acts as a first date to search
                                                    the sales invoices
                                                    from.</span>
                                            </span>
                                        </b-input-group>
                                        <!-- <b-tooltip target="mapper_placed_at" triggers="hover" placement="top">
                                            This date also acts as a first date to search the sales invoices
                                            from</b-tooltip> -->
                                        <b-input-group style="margin-top:-18px">
                                            <daterangepicker style="width:auto !important" size="sm" ref="date"
                                                v-model="mapper_placed_at" :disabled="readonly" :opens="'right'"
                                                :single-date-picker="'single'" :locale-data="{
                                                    direction: 'ltr',
                                                    format: 'dd/mm/yyyy HH:MM',
                                                    daysOfWeek: [
                                                        'Sun',
                                                        'Mon',
                                                        'Tue',
                                                        'Wed',
                                                        'Thu',
                                                        'Fri',
                                                        'Sat',
                                                    ],
                                                    monthNames: [
                                                        'January',
                                                        'February',
                                                        'March',
                                                        'April',
                                                        'May',
                                                        'June',
                                                        'July',
                                                        'August',
                                                        'September',
                                                        'October',
                                                        'November',
                                                        'December',
                                                    ],
                                                    firstDay: 1,
                                                    applyLabel: 'OK',
                                                    cancelLabel: 'Cancel',
                                                }" :showDropdowns="true" :ranges="false" :linkedCalendars="true"
                                                :timePicker="true" :timePicker24Hour="true" :time-picker-increment="1">
                                            </daterangepicker>
                                            <b-input-group-append>
                                                <b-button size="sm" variant="outline-secondary" :disabled="readonly"
                                                    @click="mapper_placed_at = {
                                                        startDate: null,
                                                        endDate: null,
                                                    }">
                                                    <i class="la la-times"></i>
                                                </b-button>
                                            </b-input-group-append>
                                        </b-input-group>
                                    </b-form-group>
                                </div>
                                <div class="px-3 col-12 col-sm-6 col-md-4 col-lg-3">
                                    <b-form-group label="Value GBP" label-for="total" label-cols="12">
                                        <b-input-group class="treeselect_all" style="left:75px; top:-29px">
                                            <!-- <i class="fa fa-info-circle text-danger" id="valuegbp"></i> -->
                                            <span class="tooltip-wrap">
                                                <i class="fa fa-info-circle text-danger"></i>
                                                <span class="tooltip-text">Enter the total
                                                    value GBP of the
                                                    order including
                                                    VAT. (mandatory)</span>
                                            </span>
                                        </b-input-group>
                                        <!-- <b-tooltip target="valuegbp" triggers="hover" placement="top">Enter the total
                                            value GBP of the
                                            order including
                                            VAT. (mandatory)</b-tooltip> -->
                                        <b-input-group style="margin-top:-23px">
                                            <b-form-input type="text" v-model="item.value" :state="false"
                                                placeholder="Value GBP" size="sm"></b-form-input>
                                            <b-input-group-append>
                                                <b-button size="sm" variant="outline-secondary"
                                                    @click="item.value = '0.00'">
                                                    <i class="la la-times"></i>
                                                </b-button>
                                            </b-input-group-append>
                                        </b-input-group>
                                    </b-form-group>
                                </div>

                                <div class="px-3 col-12 col-sm-6 col-md-4 col-lg-3">
                                    <b-form-group label-cols="12" label="Status" label-size="sm">
                                        <treeselect placeholder="Select status..." v-model="item.status" :clearable="true"
                                            :options="status_options" :show-count="true" :flatten-search-results="true"
                                            :disable-branch-nodes="true" :matchKeys="['id']" search-nested
                                            :disabled="readonly">
                                            <!-- <div slot="value-label" slot-scope="{ node }">
                      {{ node.raw.id }}
                    </div> -->
                                        </treeselect>
                                    </b-form-group>
                                </div>
                            </div>


                            <div align-v="end" class="row nopadding my-2 mt-0 background-transparent" no-gutters>
                                <div class="col col-12 text-left text-orange mt-n2 divider ">
                                    Attachment
                                </div>
                            </div>

                            <div class="row">
                                <div class="px-3 col-12 col-sm-12 col-md-12 col-lg-6">
                                    <b-form-group label="Click x to remove or browse for document upload..."
                                        label-size="sm">
                                        <b-input-group class="treeselect_all" style="left:335px; top:-27px">
                                            <!-- <i class="fa fa-info-circle text-light" id="fileUpload"></i> -->
                                            <span class="tooltip-wrap">
                                                <i class="fa fa-info-circle text-light"></i>
                                                <span class="tooltip-text">Upload an
                                                    attachment document
                                                    (.pdf,.docx,.xlsx
                                                    or .zip) other document confirming this order. (optional)</span>
                                            </span>
                                        </b-input-group>
                                        <!-- <b-tooltip target="fileUpload" triggers="hover" placement="top">Upload an
                                            attachment document
                                            (.pdf,.docx,.xlsx
                                            or .zip) other document confirming this order. (optional)</b-tooltip> -->
                                        <b-input-group style="margin-top:-15px">
                                            <b-input-group-prepend>
                                                <b-button size="sm" title="delete" variant="outline-danger"
                                                    class="xs-button radius-0" @click="fileUpload_clear">
                                                    <i class="la la-times"></i>
                                                </b-button>
                                            </b-input-group-prepend>
                                            <b-form-file class="ml-1 z-0 input form-control" id="file-small" size="sm"
                                                ref="file-input" :multiple="false" no-drop @change="fileUpload_selected"
                                                :placeholder="fileUpload ? fileUpload.name : 'No file chosen'
                                                    " :disabled="fileUpload ? true : false"></b-form-file>
                                            <b-input-group-append>
                                                <b-button class="ml-1" size="sm" title="view file"
                                                    variant="outline-primary" @click="fileUpload_view"
                                                    :disabled="!fileUpload">
                                                    <i class="la la-download"></i>
                                                </b-button>
                                            </b-input-group-append>
                                        </b-input-group>
                                    </b-form-group>
                                </div>

                            </div>

                            <div align-v="end" class="row nopadding my-2 mt-0 background-transparent" no-gutters>
                                <div class="col text-left text-orange mt-n2 divider ">
                                    Notifications
                                </div>
                            </div>
                            <div class="row">
                                <div class="px-3 col-12 col-sm-6 col-md-6 col-lg-3">
                                    <b-form-group label="Notify Limit %" label-for="notify_limit" label-cols="12">

                                        <b-input-group class="treeselect_all" style="left:95px; top:-29px; width:50%">
                                            <div class="tooltip-row d-flex align-items-center justify-content-between">

                                                <span class="tooltip-wrap">
                                                    <i class="fa fa-info-circle text-light"></i>
                                                    <span class="tooltip-text">
                                                        When the used % reaches the notify limit %, a daily email
                                                        notification will be sent.
                                                    </span>
                                                </span>

                                                <span class="used-text" style="margin-right:-13px;">
                                                    Used: <span class="text-danger">{{ used }}</span>%
                                                </span>
                                            </div>
                                        </b-input-group>

                                        <b-input-group style="margin-top:-29px">
                                            <b-form-input type="text" v-model="item.notify_limit"
                                                placeholder="Notify Limit %" size="sm"></b-form-input>
                                            <b-input-group-append>
                                                <b-button size="sm" variant="outline-secondary"
                                                    @click="item.notify_limit = ''">
                                                    <i class="la la-times"></i>
                                                </b-button>
                                            </b-input-group-append>
                                        </b-input-group>
                                    </b-form-group>
                                </div>
                                <div class="px-3 col-12 col-sm-6 col-md-6">
                                    <b-form-group label="Notify Email" label-for="notify_email" label-cols="12">
                                        <b-input-group class="treeselect_all" style="left:82px; top:-28px">
                                            <!-- <i class="fa fa-info-circle text-light" id="notify_email"></i> -->
                                            <span class="tooltip-wrap">
                                                <i class="fa fa-info-circle text-light z-1"></i>
                                                <span class="tooltip-text">Enter email
                                                    addresses here,
                                                    separated by
                                                    commas, for all the people you wish to notify the order
                                                    about.</span>
                                            </span>
                                        </b-input-group>
                                        <!-- <b-tooltip target="notify_email" triggers="hover" placement="top">Enter email
                                            addresses here,
                                            separated by
                                            commas, for all the people you wish to notify the order about.</b-tooltip> -->
                                        <b-input-group style="margin-top:-29px">
                                            <b-form-input type="text" v-model="item.notify_email"
                                                placeholder="Notify Email" size="sm"></b-form-input>
                                            <b-input-group-append>
                                                <b-button size="sm" variant="outline-secondary"
                                                    @click="item.notify_email = ''">
                                                    <i class="la la-times"></i>
                                                </b-button>
                                            </b-input-group-append>
                                        </b-input-group>
                                    </b-form-group>
                                </div>

                                <div class="px-3 col-12 col-sm-6 col-md-4 col-lg-3">
                                    <b-form-group label-cols="12" label="Spend Manager Checked" label-size="sm"
                                        :disabled="true">
                                        <b-input-group class="treeselect_all" style="left:166px; top:-26px">
                                            <!-- <i class="fa fa-info-circle text-light" id="notify_checked"
                                                ></i> -->
                                            <span class="tooltip-wrap">
                                                <i class="fa fa-info-circle text-light"></i>
                                                <span class="tooltip-text">The date and
                                                    time the spend
                                                    manager last ran.</span>
                                            </span>
                                        </b-input-group>
                                        <!-- <b-tooltip target="notify_checked" triggers="hover" placement="top">The date and
                                            time the spend
                                            manager last ran.</b-tooltip> -->
                                        <b-input-group style="margin-top:-25px">
                                            <b-form-input :value="item.notify_at
                                                ? this.$helpers.datetimefield(item.notify_at)
                                                : null
                                                " :disabled="true"></b-form-input>
                                            <b-input-group-append>
                                                <b-button size="sm" variant="outline-secondary"
                                                    @click="item.notify_at = null">
                                                    <i class="la la-times"></i>
                                                </b-button>
                                            </b-input-group-append>
                                        </b-input-group>
                                    </b-form-group>
                                </div>
                            </div>

                            </p>
                        </b-tab>

                        <!-- <b-tab>
                            <template #title>
                                <i class="fa fa-comments-o text-primary mr-1"></i>
                                Notes</template>
                            <p class="py-3 px-0">
                                <b-row>
                                    <b-col cols="12">
                                        <b-form-group label="Notes" label-for="notes" label-cols="12">
                                            <b-form-textarea id="data" v-model="item.notes" placeholder="Notes" rows="6"
                                                class="smalltextarea"
                                                :disabled="!permissionvalid('orders.save')"></b-form-textarea>
                                        </b-form-group> </b-col></b-row>
                                <b-row>
                                    <b-col>
                                        <b-button squared size="sm" variant="outline-primary" class="mr-1"
                                            @click="timestamp">
                                            <i class="fa fa-clock-o"></i>
                                            Add a timestamp
                                        </b-button>
                                    </b-col>
                                </b-row>

                            </p>
                        </b-tab> -->


                        <!-- <b-tab v-if="idselected">
                            <template #title>
                                <i class="fa fa-history text-primary mr-1"></i> Audit
                            </template>
                            <p class="py-3 px-0">
                                <b-row>
                                    <b-col cols="12" sm="6" md="4" xl="3">
                                        <b-form-group label="ID" label-for="id" label-cols="12">
                                            <b-input-group>
                                                <b-form-input type="text" v-model="item.id" placeholder="" size="sm"
                                                    :disabled="true"></b-form-input>

                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>

                                </b-row>
                                <b-row>
                                    <b-col cols="12" sm="6" md="4" xl="3">
                                        <b-form-group label="Created At" label-for="created_at" label-cols="12">
                                            <b-input-group>
                                                <b-input-group-prepend>
                                                    <b-form-datepicker size="sm" v-model="item.created_at" button-only
                                                        label-help="" locale="en-GB"
                                                        :disabled="true"></b-form-datepicker>
                                                </b-input-group-prepend>
                                                <b-form-input size="sm" id="date" v-model="item.created_at" type="text"
                                                    placeholder="YYYY-MM-DD" autocomplete="off"
                                                    :disabled="true"></b-form-input>
                                                <b-input-group-append>
                                                    <b-button size="sm" variant="outline-secondary"
                                                        @click="item.created_at = null" :disabled="true">
                                                        <i class="la la-times"></i>
                                                    </b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>

                                    <b-col cols="12" sm="6" md="4" xl="3">
                                        <b-form-group label="Created By" label-for="created_by" label-cols="12">
                                            <b-input-group>
                                                <b-form-input type="text" v-model="item.created_by" placeholder=""
                                                    size="sm" :disabled="true"></b-form-input>
                                                <b-input-group-append>
                                                    <b-button size="sm" variant="outline-secondary"
                                                        @click="item.created_by = ''" :disabled="true">
                                                        <i class="la la-times"></i>
                                                    </b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>

                                    <b-col cols="12" sm="6" md="4" xl="3">
                                        <b-form-group label="Updated At" label-for="updated_at" label-cols="12">
                                            <b-input-group>
                                                <b-input-group-prepend>
                                                    <b-form-datepicker size="sm" v-model="item.updated_at" button-only
                                                        label-help="" locale="en-GB"
                                                        :disabled="true"></b-form-datepicker>
                                                </b-input-group-prepend>
                                                <b-form-input size="sm" id="date" v-model="item.updated_at" type="text"
                                                    placeholder="YYYY-MM-DD" autocomplete="off"
                                                    :disabled="true"></b-form-input>
                                                <b-input-group-append>
                                                    <b-button size="sm" variant="outline-secondary"
                                                        @click="item.updated_at = null" :disabled="true">
                                                        <i class="la la-times"></i>
                                                    </b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>

                                    <b-col cols="12" sm="6" md="4" xl="3">
                                        <b-form-group label="Updated By" label-for="updated_by" label-cols="12">
                                            <b-input-group>
                                                <b-form-input type="text" v-model="item.updated_by" placeholder=""
                                                    size="sm" :disabled="true"></b-form-input>
                                                <b-input-group-append>
                                                    <b-button size="sm" variant="outline-secondary"
                                                        @click="item.updated_by = ''" :disabled="true">
                                                        <i class="la la-times"></i>
                                                    </b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                            </p>
                        </b-tab> -->
                    </b-tabs>
                </b-card-body>

                <!-- v-if="!forecasts.component" -->
                <!-- v-if="user.permissions.includes('orders.save')" -->
                <b-card-footer class="nopadding mt-2">
                    <b-row no-gutters>
                        <b-col cols="8" class="text-left">
                            <b-button squared size="sm" variant="primary" @click="saveit" class="custom-btn">
                                <i class="la la-check"></i>
                                Save It
                            </b-button>
                            <div v-if="busy">
                                <i class="fa fa-spinner fa-spin text-primary"></i>
                            </div>
                            <div v-else>
                                <span v-html="message"></span>
                            </div>
                        </b-col>
                        <!-- <b-col class="text-left my-auto">
                            <div v-if="busy">
                                <i class="fa fa-spinner fa-spin text-primary"></i>
                            </div>
                            <div v-else>
                                <span v-html="message"></span>
                            </div>
                        </b-col> -->
                        <b-col class="text-right" cols="">
                            <b-button squared size="sm" variant="secondary" class="custom-btn"
                                @click="$emit('discard')">
                                <i class="la la-arrow-left pr-1"></i>
                                Back
                            </b-button>
                        </b-col>
                    </b-row>
                </b-card-footer>

            </div>
        </b-card>
    </b-overlay>
</template>

<script>
import gql from "graphql-tag";

export default {
    name: "OrdersEdit",

    mounted() {
        this.item.agent = this.user.initials;
        this.item.slac = [this.user.slac];
    },
    data() {
        return {
            busy: false,
            tabIndex: 0,
            readonly: false,
            icon: "fa fa-gavel",

            used: 0,
            mapper_placed_at: {
                startDate: this.$moment().format('YYYY-MM-DD'),
                endDate: this.$moment().format('YYYY-MM-DD'),
            },
            mapper_required_at: {
                startDate: null,
                endDate: null,
            },
            mapper_expiry_at: {
                startDate: null,
                endDate: null,
            },
            requirement: {
                slac: "Client SL A/C",
                // yourref: "Your Ref / PO (incl. Requistion Nos e.g. A,B,C)",
            },
            item: {
                //icon: "fa fa-gavel",

                id: null,
                slac: [],
                eventcode: [],
                depositref: [],
                notes: null,
                status: "1",
                agent: null,
                forecast_on: false,
                notify_limit:"90"
            },
            items: [],
            payby_options: [{ id: "IN", label: "Invoice" }],
            marginby_options: [
                { id: "COM", label: "Commission" },
                { id: "FEE", label: "Fee" },
            ],
            status_options: [
                { id: "0", label: "Complete" },
                { id: "1", label: "Active" },
                { id: "2", label: "Cancelled" },
            ],
            reasoncode_options: [],


            forecasts: {
                busy: false,
                component: null,
                debounce: 500,
                icon: "fa fa-gavel",
                tools: "back,save,refresh,export,notes,deleteconfirm",
                fields: [
                    {
                        key: "routing",
                        label: "Routing",
                        type: "text",
                        placeholder: "Routing (AAA/BBB) or * for all",
                        class: "text-right w-40pct",
                        clearable: "true",
                    },
                    {
                        key: "datetravel",
                        label: "Date Travel",
                        type: "daterangepicker",
                        placeholder: "Daterange (from-to)",
                        class: "text-right w-40pct",
                        singleDatePicker: "range",
                        opens: "left",
                        clearable: "true",
                    },
                    {
                        key: "value",
                        label: "Value",
                        type: "text",
                        class: "text-right w-40pct",
                        disabled: "true",
                    },
                ],
                items: [],
                selected: [],
                incomplete: false,
                overlap: false,
            },
        };
    },
    watch: {
        mapper_placed_at: {
            async handler(newVal, oldVal) {
                if (newVal.startDate) {
                    this.item.placed_at = this.$moment(newVal.startDate).valueOf().toString()
                } else {
                    this.item.placed_at = ''
                }
            }
        },
        mapper_required_at: {
            async handler(newVal, oldVal) {
                if (newVal.startDate) {
                    this.item.required_at = this.$moment(newVal.startDate).valueOf().toString()
                } else {
                    this.item.required_at = ''
                }
            }
        },

        mapper_expiry_at: {
            async handler(newVal, oldVal) {
                if (newVal.startDate) {
                    this.item.expiry_at = this.$moment(newVal.startDate).valueOf().toString()
                } else {
                    this.item.expiry_at = ''
                }
            }
        },

        fileUpload: {
            immediate: true,
            deep: true,
            async handler(newVal, oldVal) {
                if (newVal) {
                    console.log("watch:fileUpload", newVal);
                }
            },
        },
    },
    methods: {
        async load() {
            let variables = {
                id: this.idselected,
            };
            console.log("variables", variables);
            this.busy = true;
            try {
                const response = await this.$apollo.query({
                    query: gql`
            query orders($id: String) {
              orders(id: $id) {
                id
                description
                yourref
                placed_at
                required_at
                expiry_at
                status
                agent
                eventcode
                slac
                notes
                valueexvat
                valuevat
                value
                spent
                reclaim
                reason
                contact
                contract
                manager
                notify_email
                notify_limit
                notify_at
                payby
                depositref
                marginby
                margin
                to
                forecast_on
                data
                created_at
                created_by
                updated_at
                updated_by
             
              }
            }
          `,
                    variables,
                });

                if (response.data.orders.length > 0) {
                    this.item = response.data.orders[0];

                    if (parseFloat(this.item.spent) > 0 && parseFloat(this.item.value) > 0) {
                        this.used = ((parseFloat(this.item.spent) / parseFloat(this.item.value)) * 100).toFixed(2)
                    }

                    if (this.item.placed_at) {
                        let v = this.$moment.unix(this.item.placed_at * 0.001).utc(false).format("YYYY-MM-DD HH:mm")
                        this.mapper_placed_at = { startDate: v, endDate: v }
                    }
                    if (this.item.required_at) {
                        let v = this.$moment.unix(this.item.required_at * 0.001).utc(false).format("YYYY-MM-DD")
                        this.mapper_required_at = { startDate: v, endDate: v }
                    }
                    if (this.item.expiry_at) {
                        let v = this.$moment.unix(this.item.expiry_at * 0.001).utc(false).format("YYYY-MM-DD")
                        this.mapper_expiry_at = { startDate: v, endDate: v }
                    }

                    this.item.slac = this.item.slac ? this.item.slac.split(",") : [];
                    this.item.eventcode = this.item.eventcode
                        ? this.item.eventcode.split(",")
                        : [];
                    this.item.depositref = this.item.depositref ? this.item.depositref.split(",") : [];

                    if (this.item.data) {
                        try {
                            this.fileUpload = JSON.parse(this.item.data);
                        } catch (error) {
                            this.fileUpload = {
                                name: this.item.yourref + ".pdf",
                                data: this.item.data,
                            };
                        }
                    }


                }
            } catch (error) {
                console.log(error);
            }

            try {
                const response = await this.$apollo.query({
                    query: gql`
            query setup_ordersreasons {
              setup_ordersreasons {
                id
                label
                type
              }
            }
          `,
                });
                this.reasoncode_options = response.data.setup_ordersreasons;
            } catch (error) {
                console.log(error);
            }
            this.busy = false;
        },
        async saveit() {
            let row = this.cleanit(this.item);

            row.slac = row.slac.length > 0 ? row.slac.join(",") : null;
            row.eventcode = row.eventcode.length > 0 ? row.eventcode.join(",") : null;
            row.depositref = row.depositref.length > 0 ? row.depositref.join(",") : null;

            console.log(row);
            this.message = this.$helpers.mandatoryFields(
                {
                    slac: "Client SL A/C",
                    // yourref: "Your Ref / PO (incl. Requistion Nos e.g. A,B,C)",
                },
                row
            );
            if (this.message.length > 0) {
                return;
            }

            this.busy = true;

            let variables = { rows: [row] };

            if (this.fileUpload) {
                variables.rows[0].data = JSON.stringify(this.fileUpload);
            } else {
                variables.rows[0].data = "";
            }
            // PUT ANY NEW FORECASTS TO SAVE OBJECT
            if (this.forecasts.length > 0) {
                variables.rows[0].forecasts = this.forecasts;
            }
            delete variables.rows[0].notify_df;


            try {
                const response = await this.$apollo.mutate({
                    mutation: gql`
            mutation orders_save($rows: [Order_input], $dateformat: String) {
              orders_save(rows: $rows, dateformat: $dateformat) {
                id
                value
                spent
              }
            }
          `,
                    variables,
                });
                this.message = "<span class='text-primary'>Saved it.</span>";
                // if (response.data.orders_save.length > 0) {
                //   this.item = response.data.orders_save[0];

                //   if (parseFloat(this.item.spent) > 0 && parseFloat(this.item.value) > 0) {
                //     this.used = ((parseFloat(this.item.spent) / parseFloat(this.item.value)) * 100).toFixed(2)
                //   }
                // }

            } catch (error) {
                this.message = "<span class='text-danger'>" + error.message + "</span>";
            }

            this.busy = false;

            return;
        },
    },
};
</script>

<style>
.card {
    text-align: left !important;
}
</style>